import { Component, EventEmitter, OnInit, Output, HostListener, ElementRef , ViewChild, TemplateRef} from '@angular/core';
import {NgbModal, ModalDismissReasons}   from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {HttpClient,HttpClientModule,HttpHeaders,} from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApidataService } from '../apidata.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { Ng2SearchPipeModule } from '@ngx-maintenance/ng2-search-filter';
import { NgPipesModule } from 'ngx-pipes';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { AfterViewInit } from '@angular/core';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
@Component({
  selector: 'app-dictionary',
  standalone: true,
  imports: [NgbDatepickerModule, HttpClientModule,CommonModule,IconsFreeToolsComponent,
    ReactiveFormsModule,
    FormsModule, NgPipesModule,
    FilterPipeModule,
    Ng2SearchPipeModule,],
  templateUrl: './dictionary.component.html',
  styleUrl: './dictionary.component.css',
  providers: [ApidataService],
})
export class DictionaryComponent  implements AfterViewInit{
  closeResult = '';
  dictWord;
  searchTerm;
  dictionaryStatus = '';
  profile_id;
  showWords:Boolean =false ;
  public dictListing: any[] = [];
  filteredDictListing = [...this.dictListing];
  all_records = [];
  savefiletext2: string = '';
  dictionary;
  dictioanryon;
  activePopup: string | null = null;
  firstName;
  lastName;
  emailAddress = '';
  comefromgrammarin;
  comefromsite: boolean = false;
  isDictionaryEnabled: boolean = false;
  color: string = "black";
  isUserLoggedin: boolean = false;
  public doc_id = '';
  constructor(private modalService: NgbModal,private router: Router, private apiservice: ApidataService, private http:HttpClient ,
     private elementRef: ElementRef,  private route: ActivatedRoute,) {
    this.profile_id = localStorage.getItem('profile_id');
    this.checkLoginStatus()

  }
  @ViewChild('content', { static: true }) content: TemplateRef<any>;

  ngOnInit() {
    this.profile_id = localStorage.getItem("profile_id");
    if (!this.profile_id) {
      this.profile_id = '1';
      this.isUserLoggedin = false;
    }
    else {
      this.isUserLoggedin = true;
    }
    this.route.paramMap.subscribe(params => {
      this.doc_id = params.get('doc_id');
    });
    this.openModal();
    this.getAllDictionaryWordsByProfileID();
  }
  ngAfterViewInit() {
    this.fetchProfileData();
    this.fetchProfileData()
 this.getAllDictionaryWordsByProfileID();

  }

  checkLoginStatus() {
    this.profile_id = localStorage.getItem("profile_id");
  
    if (!this.profile_id) { 
      this.profile_id = '1';  
      this.isUserLoggedin = false;  
    } else {
      this.isUserLoggedin = true;  
    }
  
  }
  openModal() {
  
    this.modalService.open(this.content, { backdrop: 'static', keyboard: false, centered: true,  windowClass: 'my-class'});
  }


  openModels(content:any, data:any=null){
    this.modalService.open(content,{size:"lg"})
    this.updateUserDictionary();
    }
    closeModal(){
      this.modalService.dismissAll();
    }



  public getAllDictionaryWordsByProfileID() {
    this.profile_id = localStorage.getItem("profile_id");
    const token = localStorage.getItem("token");

    this.apiservice.getAllDictionaryWords(this.profile_id, token).subscribe(
      (data) => {
        this.handleDictData(data);
      }
    )
  }


  public handleDictData(data: Response) {

      let receivedData = data;
      this.all_records = receivedData["contents"];

      this.dictListing = [];

      for (let i = 0; i < this.all_records.length; i++) {
        this.dictListing.push({
          dic_id: this.all_records[i][0],
          user_id: this.all_records[i][1],
          word: this.all_records[i][2],
          doc: this.all_records[i][3],
        });
    
    }
  }
  toggleDictionary(value) {
    $('#dictLoaderonoffmsg').html(
      '<img alt="Loading" src="../assets/images/loader-ajax.gif">'
    );
    if (this.dictionaryStatus == 'on') {
      this.dictionaryStatus = 'off';
      this.apiservice
        .toggleDictionaryByProfileID(this.profile_id, this.dictionaryStatus)
        .subscribe((data) => this.handletoggleDictionaryData(data));
    } else if (this.dictionaryStatus == 'off') {
      this.dictionaryStatus = 'on';
 
      this.apiservice
        .toggleDictionaryByProfileID(this.profile_id, this.dictionaryStatus)
        .subscribe((data) => this.handletoggleDictionaryData(data));

    }
  }
  onToggleClick(event: Event): void {
    const checkbox = event.target as HTMLInputElement;

    if (checkbox.checked !== this.isDictionaryEnabled) {
      this.isDictionaryEnabled = checkbox.checked;
      this.toggleDictionary(this.isDictionaryEnabled);
    } else {
      event.preventDefault();
    }
    
  }

  updateUserDictionary() {
    let find: boolean = false;
    this.showWords = false;

    if (this.dictWord == null) {
      $('#dictLoader').html('<i class="fa fa-times-circle me-1"></i>Add at least 2 characters.');
      setTimeout(function () {
        $('#dictLoader').fadeOut('slow');
        $('#dictLoader').html('');
      }, 3000);
    }
    if (this.dictWord != null) {
      if (this.dictWord.length < 2) {
        $('#dictLoader').html('<i class="fa fa-times-circle me-1"></i> Add at least 2 characters.');
        this.color = "red";
        setTimeout(function () {
          $('#dictLoader').fadeOut('slow');
          $('#dictLoader').html('');
        }, 3000);
      } else if (this.dictWord.length > 99) {
        $('#dictLoader').html('<i class="fa fa-times-circle me-1"></i>Words must be shorter than 100 characters');
        this.color = "red";
        setTimeout(function () {
          $('#dictLoader').fadeOut('slow');
          $('#dictLoader').html('');
        }, 3000);
      } else if (this.dictWord.match(' ')) {
        $('#dictLoader').html('<i class="fa fa-times-circle me-1"></i>Your word can’t contain any spaces.');
        this.color = "red";
        setTimeout(function () {
          $('#dictLoader').fadeOut('slow');
          $('#dictLoader').html('');
        }, 3000);

      } else {
  
        for (let i = 0; i < this.all_records.length; i++) {
          var checldicwordsalready = this.all_records[i][2];
       
          if (this.dictWord === checldicwordsalready) {
            find = true;
            break;
          }
        }
        if (find) {
          $('#dictLoader').html('Word already added.');
          this.color = "green";
          setTimeout(function () {
            $('#dictLoader').fadeOut('slow');
            $('#dictLoader').html('');
          }, 3000);
        } else {
          this.apiservice
            .addDictionaryWord(this.profile_id, this.dictWord)
            .subscribe((data) => this.handleAddDictData(data));
        }
      }
    }
  }
  deleteDictWord(dic_id) {

    var c = confirm('Are you sure to delete?');
    if (c == true) {
      this.profile_id = localStorage.getItem('profile_id');
      this.apiservice.deleteDictWordByID(this.profile_id, dic_id).subscribe(
        (data) => {
          this.handleDictDataDeleted(data);
        }
      
      );
    }
  }


  handleDictDataDeleted(data: Response) {
  
    let receivedData = data;
    this.all_records = receivedData['contents'];

    this.dictListing = [];

    for (let i = 0; i < this.all_records.length; i++) {
      this.dictListing.push({
        dic_id: this.all_records[i][0],
        user_id: this.all_records[i][1],
        word: this.all_records[i][2],
        doc: this.all_records[i][3],
      });
    }
 

    $('#savefiletext2').html('<i class="fas fa-check-circle me-1"></i>Deleted Successfully!');
    setTimeout(function () {
      $('#savefiletext2').hide();
 $('#savefiletext2').html('');
    }, 3000);
    setTimeout(function () {
      $('#dictLoader').fadeOut('slow');
      $('#dictLoader').html('');
    }, 2000);

    // }
  }

  handleAddDictData(data: Response) {
   
    this.dictWord = '';

    let receivedData = data;
    this.all_records = receivedData['contents'];
    $('#savefiletext3').html('<i class="fas fa-check-circle me-1"></i>Added Successfully!');
    $('#savefiletext3').show();
    setTimeout(function () {
      $('#savefiletext3').hide();
      $('#savefiletext3').html('');
    }, 3000);
    this.dictListing = [];

    for (let i = 0; i < this.all_records.length; i++) {
      this.dictListing.push({
        dic_id: this.all_records[i][0],
        user_id: this.all_records[i][1],
        word: this.all_records[i][2],
        doc: this.all_records[i][3],
      });
    }

    setTimeout(function () {
      $('#dictLoader').fadeOut('slow');
      $('#dictLoader').html('');
    }, 2000);
 
  }

  handletoggleDictionaryData(data: Response) {

    this.dictionary = data;
    this.dictioanryon = this.dictionary.contents;
    this.dictWord = '';
    $('#dictLoaderonoffmsg').html('<i class="fas fa-check-circle me-1"></i>Updated Successfully');
    this.color = "green";

    setTimeout(function () {
      $('#dictLoaderonoffmsg').fadeOut('slow');
      $('#dictLoaderonoffmsg').html('');
    }, 3000);
    // }
  }
  public LoadProfileData(data: Response) {
    let receivedData = data;
    this.firstName = receivedData['contents'][0][1];

    this.lastName = receivedData['contents'][0][2];
    this.emailAddress = receivedData['contents'][0][0];
    this.dictionaryStatus = receivedData['contents'][0][3];

    this.comefromgrammarin = receivedData['contents'][0][4];
    if (this.comefromgrammarin === 'grammarin') {
 
      this.comefromsite = true;
     
    }
    else{
      this.comefromsite= false;
    }
    if (this.dictionaryStatus == 'off') {
      document.getElementById('bopis').toggleAttribute('unchecked');
    }
    if (this.dictionaryStatus == 'on') {
      document.getElementById('bopis').toggleAttribute('checked');
    }
  }
  public fetchProfileData() {
    this.profile_id = localStorage.getItem('profile_id');
    this.apiservice.getUserProfileContents(this.profile_id).subscribe((data) =>
      this.LoadProfileData(data)
    );
  }
  // dictionary end





}
